import { useLang } from "@/context/LangContext";
import { useNavigate } from "react-router-dom";
import { ChevronLeft, ChevronRight } from "lucide-react";

export default function Terms() {
  const { lang, isRTL } = useLang();
  const navigate = useNavigate();
  const Chev = isRTL ? ChevronRight : ChevronLeft;

  return (
    <div className="min-h-screen bg-white">
      <div className="sticky top-0 bg-white border-b border-[#EAEAEA] z-10">
        <div className="max-w-3xl mx-auto px-4 py-3 flex items-center gap-3">
          <button onClick={() => navigate(-1)} className="w-9 h-9 rounded-full hover:bg-[#F5F5F5] flex items-center justify-center">
            <Chev className="w-5 h-5" />
          </button>
          <h1 className="font-bold text-lg">{lang === "ar" ? "شروط الاستخدام" : "Terms of Service"}</h1>
        </div>
      </div>
      <article className="max-w-3xl mx-auto px-5 py-6 text-[#1A1A1A]">
        {lang === "ar" ? (
          <div className="space-y-4 text-[14px]">
            <p className="text-xs text-[#6B6B6B]">آخر تحديث: فبراير 2026</p>

            <Section title="١. الموافقة على الشروط">
              <p>باستخدامك تطبيق "جايك"، فإنك توافق على هذه الشروط. إذا لم توافق، يُرجى عدم استخدام التطبيق.</p>
            </Section>

            <Section title="٢. وصف الخدمة">
              <p>جايك منصة لتوصيل الطلبات من المطاعم إلى العملاء في المملكة العربية السعودية، تربط بين العميل والمطعم والمندوب.</p>
            </Section>

            <Section title="٣. الحساب">
              <ul className="list-disc ps-5 space-y-1">
                <li>يجب أن يكون عمرك ١٨ سنة أو أكثر</li>
                <li>المعلومات التي تقدّمها يجب أن تكون صحيحة</li>
                <li>أنت مسؤول عن سرية كلمة المرور</li>
                <li>نحتفظ بحق إيقاف أي حساب يخالف الشروط</li>
              </ul>
            </Section>

            <Section title="٤. الطلبات والدفع">
              <ul className="list-disc ps-5 space-y-1">
                <li>جميع الأسعار بالريال السعودي وتشمل ضريبة القيمة المضافة</li>
                <li>الدفع يتم إلكترونياً أو نقداً عند الاستلام</li>
                <li>المطعم له الحق في رفض أي طلب لأسباب خارجة عن إرادتنا (نفاد المخزون، إغلاق، إلخ)</li>
                <li>في حال الرفض، يُسترد المبلغ كاملاً خلال ٣-٧ أيام عمل</li>
              </ul>
            </Section>

            <Section title="٥. التوصيل">
              <ul className="list-disc ps-5 space-y-1">
                <li>أوقات التوصيل تقديرية وقد تختلف بسبب ظروف الطريق أو الطقس</li>
                <li>العميل مسؤول عن تقديم عنوان دقيق</li>
                <li>يجب أن يكون العميل متاحاً لاستلام الطلب في الوقت المتوقع</li>
              </ul>
            </Section>

            <Section title="٦. الاسترداد والإلغاء">
              <ul className="list-disc ps-5 space-y-1">
                <li>يمكن إلغاء الطلب قبل أن يقبله المطعم بدون رسوم</li>
                <li>بعد قبول المطعم، لا يمكن الإلغاء</li>
                <li>في حال استلام طلب معيب أو غير مطابق، تواصل معنا خلال ٢٤ ساعة</li>
              </ul>
            </Section>

            <Section title="٧. السلوك المحظور">
              <ul className="list-disc ps-5 space-y-1">
                <li>استخدام التطبيق لأغراض غير مشروعة</li>
                <li>محاولة اختراق النظام</li>
                <li>الإساءة للمناديب أو موظفي المطاعم</li>
              </ul>
            </Section>

            <Section title="٨. إخلاء المسؤولية">
              <p>نقدّم الخدمة "كما هي". لا نتحمل مسؤولية جودة الطعام المقدّم من المطاعم، هذه مسؤولية المطعم مباشرة.</p>
            </Section>

            <Section title="٩. تعديل الشروط">
              <p>نحتفظ بحق تعديل هذه الشروط في أي وقت. استمرار استخدامك للتطبيق يعني موافقتك على التعديلات.</p>
            </Section>

            <Section title="١٠. القانون المطبّق">
              <p>تخضع هذه الشروط لأنظمة المملكة العربية السعودية، وتختص محاكم الرياض بالنظر في أي نزاع.</p>
            </Section>

            <Section title="١١. التواصل">
              <p>📧 <a className="text-[#E05D3A]" href="mailto:support@jayek.sa">support@jayek.sa</a></p>
            </Section>
          </div>
        ) : (
          <div className="space-y-4 text-[14px]">
            <p className="text-xs text-[#6B6B6B]">Last updated: February 2026</p>

            <Section title="1. Agreement">
              <p>By using Jayek, you agree to these terms. If you don't agree, please do not use the app.</p>
            </Section>

            <Section title="2. Service Description">
              <p>Jayek is a food-delivery platform connecting customers, restaurants, and drivers in Saudi Arabia.</p>
            </Section>

            <Section title="3. Account">
              <ul className="list-disc ps-5 space-y-1">
                <li>You must be 18+ to use the service</li>
                <li>Information you provide must be accurate</li>
                <li>You are responsible for password confidentiality</li>
                <li>We may suspend accounts that violate these terms</li>
              </ul>
            </Section>

            <Section title="4. Orders & Payment">
              <ul className="list-disc ps-5 space-y-1">
                <li>All prices are in Saudi Riyals (SAR) including VAT</li>
                <li>Payment via card or cash on delivery</li>
                <li>Restaurants may refuse orders due to stock, closure, etc.</li>
                <li>Refunds processed within 3-7 business days</li>
              </ul>
            </Section>

            <Section title="5. Delivery">
              <ul className="list-disc ps-5 space-y-1">
                <li>Delivery times are estimates</li>
                <li>You are responsible for accurate address info</li>
                <li>Must be available to receive the order</li>
              </ul>
            </Section>

            <Section title="6. Refunds & Cancellations">
              <ul className="list-disc ps-5 space-y-1">
                <li>Free cancellation before restaurant accepts</li>
                <li>No cancellation after restaurant accepts</li>
                <li>For defective orders, contact us within 24 hours</li>
              </ul>
            </Section>

            <Section title="7. Prohibited Conduct">
              <ul className="list-disc ps-5 space-y-1">
                <li>Using the app for illegal purposes</li>
                <li>Attempting to hack the system</li>
                <li>Abusing drivers or restaurant staff</li>
              </ul>
            </Section>

            <Section title="8. Disclaimer">
              <p>Service provided "as-is". Food quality is the restaurant's direct responsibility.</p>
            </Section>

            <Section title="9. Changes to Terms">
              <p>We may modify these terms at any time. Continued use means you accept changes.</p>
            </Section>

            <Section title="10. Governing Law">
              <p>These terms are governed by Saudi Arabia law. Riyadh courts have exclusive jurisdiction.</p>
            </Section>

            <Section title="11. Contact">
              <p>📧 <a className="text-[#E05D3A]" href="mailto:support@jayek.sa">support@jayek.sa</a></p>
            </Section>
          </div>
        )}
      </article>
    </div>
  );
}

function Section({ title, children }) {
  return (
    <section>
      <h2 className="font-bold text-[15px] text-[#E05D3A] mb-1.5">{title}</h2>
      <div className="text-[#1A1A1A] leading-relaxed space-y-1.5">{children}</div>
    </section>
  );
}
